export default "__VITE_ASSET__CEJurLWi__"